import { useState } from 'react';
import { testimonials } from '../../../mocks/testimonials';

export default function TestimonialsSection() {
  const [active, setActive] = useState(0);

  const prev = () => setActive((a) => (a === 0 ? testimonials.length - 1 : a - 1));
  const next = () => setActive((a) => (a === testimonials.length - 1 ? 0 : a + 1));

  const getVisible = () => {
    const items = [];
    for (let i = 0; i < 3; i++) {
      items.push(testimonials[(active + i) % testimonials.length]);
    }
    return items;
  };

  return (
    <section className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-6">
          <div>
            <span className="text-amber-600 text-xs font-bold uppercase tracking-widest mb-3 block">
              Social Proof
            </span>
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-stone-900">
              What Creators Are Saying
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <button
              onClick={prev}
              className="w-10 h-10 flex items-center justify-center rounded-full border border-stone-300 hover:border-amber-400 hover:bg-amber-50 text-stone-600 hover:text-amber-600 transition-all cursor-pointer"
            >
              <i className="ri-arrow-left-line text-base" />
            </button>
            <button
              onClick={next}
              className="w-10 h-10 flex items-center justify-center rounded-full border border-stone-300 hover:border-amber-400 hover:bg-amber-50 text-stone-600 hover:text-amber-600 transition-all cursor-pointer"
            >
              <i className="ri-arrow-right-line text-base" />
            </button>
          </div>
        </div>

        {/* Testimonial Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {getVisible().map((testimonial, i) => (
            <div
              key={`${testimonial.id}-${i}`}
              className={`bg-white border rounded-2xl p-7 transition-all duration-300 ${
                i === 1
                  ? 'border-amber-300 shadow-lg scale-[1.02]'
                  : 'border-stone-200'
              }`}
            >
              {/* Stars */}
              <div className="flex gap-1 mb-5">
                {Array.from({ length: testimonial.rating }).map((_, s) => (
                  <i key={s} className="ri-star-fill text-amber-400 text-sm" />
                ))}
              </div>

              {/* Quote */}
              <p className="text-stone-600 text-sm leading-relaxed mb-6 italic">
                &ldquo;{testimonial.quote}&rdquo;
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-5 border-t border-stone-100">
                <div className={`w-10 h-10 flex items-center justify-center rounded-full text-white text-sm font-bold flex-shrink-0 ${testimonial.color}`}>
                  {testimonial.initials}
                </div>
                <div>
                  <p className="text-stone-900 font-semibold text-sm">{testimonial.name}</p>
                  <p className="text-stone-400 text-xs mt-0.5">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-2 mt-10">
          {testimonials.map((_, i) => (
            <button
              key={i}
              onClick={() => setActive(i)}
              className={`rounded-full transition-all cursor-pointer ${
                i === active ? 'w-6 h-2 bg-amber-500' : 'w-2 h-2 bg-stone-300 hover:bg-stone-400'
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
